import '@fontsource-variable/plus-jakarta-sans';
import './styles.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { reloadForUpdate } from './app/error-screen';
import { router } from './app/router';
import { resumeSession } from './lib/auth';
import { queryClient } from './lib/query';

void resumeSession();

// A screen file from before an update is gone: reload once into the new version instead of failing.
window.addEventListener('vite:preloadError', (e) => {
  if (reloadForUpdate()) e.preventDefault();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
